import React from 'react';
import './Labs.css';

const labsProjects = [
  {
    id: 'laterloom',
    name: 'Laterloom',
    tagline: 'Future notes, handled with more care.',
    description:
      'A quieter revisit of time-based messaging focused on intentional delivery, light structure, and a more considered personal experience.',
    features: ['Intentional prompts', 'Private message drafting', 'Timed delivery windows'],
    status: 'Experimental',
  },
  {
    id: 'dreamsout',
    name: 'DreamsOut',
    tagline: 'Dream capture without the spectacle.',
    description:
      'An early exploration in reflective dream journaling that keeps the interface calm, the inputs simple, and the insights secondary to the writing.',
    features: ['Low-friction logging', 'Pattern review', 'Gentle AI assistance'],
    status: 'Experimental',
  },
];

const Labs = () => {
  return (
    <main id="main-content" className="labs-page" role="main">
      <section className="labs-hero" aria-labelledby="labs-hero-heading">
        <div className="container">
          <span className="labs-label">BACIMO Labs</span>
          <h1 id="labs-hero-heading" className="labs-title">
            Curated experiments for
            <span className="highlight"> thoughtful exploration</span>
          </h1>
          <p className="labs-intro">
            Labs is where BACIMO keeps a small set of intentional experiments in view. These concepts stay secondary to live products while giving promising ideas room to mature with care.
          </p>
        </div>
      </section>

      <section className="projects-section" aria-labelledby="projects-heading">
        <div className="container">
          <div className="projects-heading-block">
            <h2 id="projects-heading" className="projects-heading">Current experiments</h2>
            <p className="projects-kicker">
              Early concepts, kept deliberately focused and clearly separate from BACIMO&apos;s production portfolio.
            </p>
          </div>

          <div className="projects-grid" role="list" aria-label="Curated experiments list">
            {labsProjects.map((project, index) => (
              <article
                key={project.id}
                className="project-card"
                style={{ animationDelay: `${index * 90}ms` }}
                role="listitem"
              >
                <div className="project-header">
                  <div className="project-info">
                    <p className="project-eyebrow">BACIMO Labs concept</p>
                    <h3 className="project-name">{project.name}</h3>
                    <p className="project-tagline">{project.tagline}</p>
                  </div>
                  <span
                    className="project-status"
                    aria-label={`Status: ${project.status}`}
                  >
                    {project.status}
                  </span>
                </div>

                <p className="project-description">{project.description}</p>

                <ul className="project-features" aria-label={`${project.name} features`}>
                  {project.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="labs-about" aria-labelledby="labs-about-heading">
        <div className="container">
          <div className="about-content">
            <h2 id="labs-about-heading">Why Labs exists</h2>
            <p>
              BACIMO Labs gives promising ideas a measured place to evolve before they earn broader product attention. The goal is signal, not volume.
            </p>
            <p>
              Some experiments may eventually inform live products. Others simply help clarify what deserves further investment.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Labs;
